/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerEnquiryResponse as ModelsCustomerCustomerEnquiryResponse } from '../../models/Models/Customer/customer-enquiry-response';

export interface V4CustomersMeNotificationsNotificationIdDelete$Xml$Params {
  notificationId: string;
}

export function v4CustomersMeNotificationsNotificationIdDelete$Xml(http: HttpClient, rootUrl: string, params: V4CustomersMeNotificationsNotificationIdDelete$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>> {
  const rb = new RequestBuilder(rootUrl, v4CustomersMeNotificationsNotificationIdDelete$Xml.PATH, 'delete');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerCustomerEnquiryResponse>;
    })
  );
}

v4CustomersMeNotificationsNotificationIdDelete$Xml.PATH = '/v4/customers/me/notifications/{notificationId}';
